import { Ray, Vector2 } from '@seddi/three';
import { setHoverGraphicId, setSelectedGraphicId } from '../../store/appSlice';
const DRAG_THRESHOLD = 0.005;
export class PickControls {
    constructor(camera, canvas, raycaster, dispatch) {
        this.enabled = true;
        this.isDown = false;
        this.isDrag = false;
        this.isDirty = false;
        this.pointer = new Vector2();
        this.pointerDown = new Vector2();
        this.ray = new Ray();
        this.camera = camera;
        this.canvas = canvas;
        this.raycaster = raycaster;
        this.dispatch = dispatch;
        const scope = this;
        this.onPointerDown = function (event) {
            if (!scope.enabled)
                return;
            if (event.button === 0) {
                scope.pointer.x = (event.offsetX / scope.canvas.clientWidth) * 2 - 1;
                scope.pointer.y = -(event.offsetY / scope.canvas.clientHeight) * 2 + 1;
                scope.ray.origin.setFromMatrixPosition(scope.camera.matrixWorld);
                scope.ray.direction
                    .set(scope.pointer.x, scope.pointer.y, 0.5)
                    .unproject(scope.camera)
                    .sub(scope.ray.origin)
                    .normalize();
                scope.raycaster.intersectLogos(scope.ray);
                scope.isDown = true;
                scope.pointerDown.copy(scope.pointer);
                canvas.setPointerCapture(event.pointerId);
                canvas.addEventListener('pointerup', onPointerUp);
            }
        };
        this.onPointerMove = function (event) {
            var _a, _b;
            if (!scope.enabled)
                return;
            const { camera, canvas, pointer, ray, raycaster } = scope;
            pointer.x = (event.offsetX / canvas.clientWidth) * 2 - 1;
            pointer.y = -(event.offsetY / canvas.clientHeight) * 2 + 1;
            if (scope.isDown && !scope.isDrag) {
                scope.isDrag = scope.pointerDown.distanceTo(scope.pointer) > DRAG_THRESHOLD;
            }
            ray.origin.setFromMatrixPosition(camera.matrixWorld);
            ray.direction.set(pointer.x, pointer.y, 0.5).unproject(camera).sub(ray.origin).normalize();
            const hit = raycaster.intersectLogos(ray);
            const nextHover = (_a = hit.logoId) !== null && _a !== void 0 ? _a : null;
            if (nextHover !== ((_b = scope.hover) !== null && _b !== void 0 ? _b : null)) {
                dispatch(setHoverGraphicId(nextHover));
            }
        };
        function onPointerUp(event) {
            var _a;
            if (!scope.isDrag) {
                if (scope.hover !== scope.selection) {
                    dispatch(setSelectedGraphicId((_a = scope.hover) !== null && _a !== void 0 ? _a : null));
                }
            }
            scope.canvas.releasePointerCapture(event.pointerId);
            scope.canvas.removeEventListener('pointerup', onPointerUp);
            scope.isDown = false;
            scope.isDrag = false;
        }
    }
    update() {
        var _a;
        if (!this.enabled || !this.isDirty)
            return;
        this.isDirty = false;
        const { dispatch, camera, hover, pointer, ray, raycaster } = this;
        ray.origin.setFromMatrixPosition(camera.matrixWorld);
        ray.direction.set(pointer.x, pointer.y, 0.5).unproject(camera).sub(ray.origin).normalize();
        const hit = raycaster.intersectLogos(ray);
        const nextHover = (_a = hit.logoId) !== null && _a !== void 0 ? _a : null;
        if (nextHover !== (hover !== null && hover !== void 0 ? hover : null)) {
            dispatch(setHoverGraphicId(nextHover));
        }
    }
    dispose() { }
}
